module.exports = __webpack_public_path__ + "static/img/aptozen2.96f5ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aptozen2.png
// module id = G+dZ
// module chunks = 10